<template>
  <Layout :tituloPagina="'WhatsApp'">
    <div class="wa-app-wrapper">
      <!-- WhatsApp Container Box -->
      <div class="wa-main-card shadow-sm">

        <!-- Mobile Backdrop Overlay -->
        <div v-if="sidebarVisible" class="wa-sidebar-backdrop d-lg-none" @click="sidebarVisible = false"></div>

        <!-- ================= LEFT SIDEBAR (CHATS LIST) ================= -->
        <CmpSidebarChats :conversaciones="conversaciones" :conversaciones-archivadas="conversacionesArchivadas"
          :total-archivados-servidor="totalArchivados" :total-no-leidos-servidor="estadoWhatsapp.mensajesNuevos"
          :cargando-conversaciones="tabActiva === 'archivados' ? cargandoArchivadas : cargandoConversaciones"
          :chat-activo-id="chatActivoId" :sidebar-visible="sidebarVisible" :tab-activa="tabActiva" :busqueda="busqueda"
          :pag="tabActiva === 'archivados' ? paginaArchivados : pagina"
          :totpag="tabActiva === 'archivados' ? ultimaPaginaArchivados : ultima_pagina" :epp="por_pagina"
          :procesando-bloqueo="procesandoBloqueo"
          @update:sidebar-visible="sidebarVisible = $event" @buscar="buscar" @cambiar-tab="cambiarTab"
          @cargar-pagina="cargarPagina" @epp-actualizado="actualizarEpp" @seleccionar-chat="seleccionarChat"
          @ir-a-detalle-cliente="irADetalleCliente" @archivar-contacto="archivarContacto"
          @desarchivar-contacto="desarchivarContacto" @marcar-no-leido="marcarComoNoLeido"
          @fijar-contacto="fijarContacto" @silenciar-contacto="silenciarContacto" @vaciar-chat="vaciarChat"
          @bloquear-contacto="bloquearContacto" @desbloquear-contacto="desbloquearContacto"
          @eliminar-chat="eliminarChat" @abrir-modal-asignar-cliente="abrirModalAsignarCliente"
          @eliminar-telefono-cliente="eliminarTelefonoCliente"
          @abrir-modal-inicializar-conversacion="abrirModalInicializarConversacion" />

        <!-- ================= RIGHT CHAT WINDOW ================= -->
        <CmpVentanaChat :chat-seleccionado="chatSeleccionado" :mensajes="mensajesChatActivo"
          :cargando-mensajes="cargandoMensajes" :cargando-mas-mensajes="cargandoMasMensajes"
          :no-hay-mas-mensajes-historicos="noHayMasMensajesHistoricos" :enviando-mensaje="enviandoMensaje"
          :enviando-plantilla-inicio="enviandoPlantillaInicio" :panel-info-visible="panelInfoVisible"
          :procesando-bloqueo="procesandoBloqueo"
          @cargar-mas-mensajes="cargarMasMensajesHistoricos"
          @enviar-mensaje="enviarMensaje" @inicializar-conversacion="inicializarConversacion"
          @abrir-sidebar="sidebarVisible = true" @toggle-panel-info="panelInfoVisible = !panelInfoVisible"
          @abrir-panel-info="panelInfoVisible = true" @cerrar-chat="cerrarChat"
          @ir-a-detalle-cliente="irADetalleCliente" @vaciar-chat="vaciarChat"
          @bloquear-contacto="bloquearContacto" @desbloquear-contacto="desbloquearContacto"
          @eliminar-chat="eliminarChat"
          @abrir-modal-asignar-cliente="abrirModalAsignarCliente"
          @eliminar-telefono-cliente="eliminarTelefonoCliente" />

        <!-- ================= RIGHT CONTACT INFO PANEL ("Info. del contacto") ================= -->
        <CmpInfoContacto v-if="chatSeleccionado && panelInfoVisible" :chat="chatSeleccionado"
          :visible="panelInfoVisible" :procesando-bloqueo="procesandoBloqueo"
          @cerrar="panelInfoVisible = false" @ir-a-detalle-cliente="irADetalleCliente"
          @archivar-contacto="archivarContacto" @desarchivar-contacto="desarchivarContacto" @vaciar-chat="vaciarChat"
          @bloquear-contacto="bloquearContacto" @desbloquear-contacto="desbloquearContacto"
          @eliminar-chat="eliminarChat" @abrir-modal-asignar-cliente="abrirModalAsignarCliente"
          @eliminar-telefono-cliente="eliminarTelefonoCliente" />

      </div>

      <!-- Modal para asignar teléfono a un cliente -->
      <MdlAsignarClienteWhatsapp ref="mdlAsignarCliente" @cliente-asignado="onClienteAsignado" />

      <!-- Modal para inicializar conversación nueva -->
      <MdlInicializarConversacionWhatsapp ref="mdlInicializarConversacion"
        @conversacion-iniciada="onConversacionIniciada" />

      <!-- Modal para previsualizar/editar variables y enviar plantilla de inicio -->
      <MdlEnviarPlantillaInicioWhatsapp ref="mdlEnviarPlantilla"
        @plantilla-enviada="onPlantillaEnviada" />
    </div>
  </Layout>
</template>

<script>
import Swal from "sweetalert2";
import Layout from "@/views/layouts/main.vue";
import WhatsappSrv from "@/services/WhatsappSrv.js";
// import SistemaSrv from "@/services/SistemaSrv.js";

import {
  escucharWhatsappGlobal,
  dejarDeEscucharWhatsappGlobal,
  escucharMensajesConversacion,
  dejarDeEscucharMensajesConversacion
} from "@/broadcasting/main.js";
import { estadoWhatsapp, cargarMensajesNuevosWhatsapp } from "@/services/WhatsappEstado.js";
import { solicitarPermisoNotificaciones } from "@/services/WhatsappNotificaciones.js";
import CmpSidebarChats from "./CmpSidebarChats.vue";
import CmpVentanaChat from "./CmpVentanaChat.vue";
import CmpInfoContacto from "./CmpInfoContacto.vue";
import MdlAsignarClienteWhatsapp from "./MdlAsignarClienteWhatsapp.vue";
import MdlInicializarConversacionWhatsapp from "./MdlInicializarConversacionWhatsapp.vue";
import MdlEnviarPlantillaInicioWhatsapp from "./MdlEnviarPlantillaInicioWhatsapp.vue";
import { eliminarCacheChat, guardarConversacionEnCache, esSaliente, obtenerObjetoFecha } from "./whatsappHelpers.js";

export default {
  name: "MensajesWhatsapp",
  components: {
    Layout,
    CmpSidebarChats,
    CmpVentanaChat,
    CmpInfoContacto,
    MdlAsignarClienteWhatsapp,
    MdlInicializarConversacionWhatsapp,
    MdlEnviarPlantillaInicioWhatsapp
  },
  data() {
    return {
      busqueda: "",
      sidebarVisible: false,
      panelInfoVisible: false,
      conversaciones: [],
      conversacionesArchivadas: [],
      chatSeleccionado: null,
      chatActivoId: null,
      tabActiva: "recientes",
      mensajesChatActivo: [],
      canalActivoNumero: null,
      cargandoConversaciones: false,
      cargandoArchivadas: false,
      pagina: 1,
      paginaArchivados: 1,
      por_pagina: parseInt(localStorage.getItem("argusblack.whatsapp.por_pagina") || 10),
      ultima_pagina: 1,
      ultimaPaginaArchivados: 1,
      totalConversaciones: 0,
      totalArchivados: 0,
      estadoWhatsapp,
      cargandoMensajes: false,
      cargandoMasMensajes: false,
      noHayMasMensajesHistoricos: false,
      enviandoMensaje: false,
      enviandoPlantillaInicio: false,
      procesandoBloqueo: false,
      abortControllerMensajes: null,
      timerDebounceConversaciones: null
    };
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.verificarSeleccionPorRuta();
      }
    }
  },
  mounted() {
    try {
      localStorage.removeItem("argusblack.whatsapp.chat_activo");
    } catch (e) { }

    // 0. Cargar conversaciones en caché inmediatamente desde LocalStorage (0ms)
    this.cargarConversacionesDeCache();

    // Si viene por query o parámetro en la ruta, verificarlo de inmediato (0ms)
    this.verificarSeleccionPorRuta();

    // 1. Canal global 'whatsapp' -> Evento 'WebSocket\ConversacionesWhatsapp'
    solicitarPermisoNotificaciones().catch(() => { });
    escucharWhatsappGlobal(this.onConversacionesWhatsapp);

    // 2. Carga en segundo plano desde el VPS
    this.cargarConversaciones();
  },
  beforeUnmount() {
    if (this.abortControllerMensajes) {
      this.abortControllerMensajes.abort();
      this.abortControllerMensajes = null;
    }
    if (this.timerDebounceConversaciones) {
      clearTimeout(this.timerDebounceConversaciones);
      this.timerDebounceConversaciones = null;
    }
    if (this.chatSeleccionado) {
      const idTelefono = this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente;
      if (idTelefono) {
        WhatsappSrv.actualizarChateando(idTelefono, 0).catch(() => { });
      }
      this.chatSeleccionado.chateando = 0;
    }
    this.desuscribirCanalConversacion();
    dejarDeEscucharWhatsappGlobal(this.onConversacionesWhatsapp);
  },
  methods: {
    guardarConversacionEnCache,
    eliminarCacheChat,
    cargarConversacionesDeCache() {
      try {
        const rawArchivadas = localStorage.getItem("argusblack.whatsapp.conversaciones_archivadas");
        if (rawArchivadas) {
          const parsedArch = JSON.parse(rawArchivadas);
          if (Array.isArray(parsedArch)) {
            this.conversacionesArchivadas = parsedArch;
            this.totalArchivados = parsedArch.length;
          }
        }
      } catch (e) { }

      try {
        const raw = localStorage.getItem("argusblack.whatsapp.conversaciones");
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.conversaciones = parsed.filter((c) => c && !Number(c.archivado));

            // Si hay parámetros en ruta, seleccionarlo de inmediato
            if (this.$route && (this.$route.query?.id_telefono || this.$route.query?.numero || this.$route.query?.id_cliente || this.$route.params?.id_cliente || this.$route.params?.id_telefono)) {
              this.verificarSeleccionPorRuta();
            }
          }
        }
      } catch (e) {
        console.warn("[WhatsApp Cache] Error al cargar conversaciones de LocalStorage:", e);
      }
    },
    suscribirCanalConversacion(numeroTelefono) {
      if (!numeroTelefono) return;
      if (this.canalActivoNumero === numeroTelefono) return;

      this.desuscribirCanalConversacion();
      this.canalActivoNumero = numeroTelefono;

      // Canal 'whatsapp.{numeroTelefono}' -> Evento 'WebSocket\MensajeWhatsapp'
      escucharMensajesConversacion(numeroTelefono, this.onMensajeWhatsapp);
    },
    desuscribirCanalConversacion() {
      if (this.canalActivoNumero) {
        dejarDeEscucharMensajesConversacion(this.canalActivoNumero);
        this.canalActivoNumero = null;
      }
    },
    cargarConversaciones() {
      if (this.tabActiva === "archivados") {
        this.cargarConversacionesArchivadas();
      } else {
        this.cargarConversacionesRecientes();
      }
      this.cargarMensajesNuevos(false);
    },
    cargarMensajesNuevos(forzar = false) {
      cargarMensajesNuevosWhatsapp(forzar).catch(() => { });
    },
    cargarConversacionesRecientes() {
      if (this.cargandoConversaciones) return;
      this.cargandoConversaciones = true;

      const params = {
        archivado: 0,
        pagina: this.pagina,
        por_pagina: this.por_pagina,
        porPagina: this.por_pagina,
        per_page: this.por_pagina
      };
      if (this.busqueda && this.busqueda.trim()) {
        params.busqueda = this.busqueda.trim();
        params.search = this.busqueda.trim();
      }

      WhatsappSrv.conversacionesRecientes(params)
        .then((response) => {
          if (response && response.data) {
            const res = response.data;
            let listado = [];
            if (Array.isArray(res)) {
              listado = res;
            } else if (res.data && Array.isArray(res.data)) {
              listado = res.data;
            } else if (res.conversaciones && Array.isArray(res.conversaciones)) {
              listado = res.conversaciones;
            }

            // Metadatos de paginación si el backend los retorna
            if (res.last_page || res.ultima_pagina || res.totpag) {
              this.ultima_pagina = Number(res.last_page || res.ultima_pagina || res.totpag) || 1;
            } else if (res.total !== undefined && this.por_pagina > 0) {
              this.ultima_pagina = Math.ceil(Number(res.total) / this.por_pagina) || 1;
            } else {
              this.ultima_pagina = 1;
            }

            if (res.current_page || res.pagina) {
              this.pagina = Number(res.current_page || res.pagina) || this.pagina;
            }
            if (res.total !== undefined) {
              this.totalConversaciones = Number(res.total);
            }

            this.conversaciones = listado;

            // Guardar en LocalStorage si no es una búsqueda filtrada y es la página 1
            if ((!this.busqueda || !this.busqueda.trim()) && this.pagina === 1) {
              try {
                localStorage.setItem("argusblack.whatsapp.conversaciones", JSON.stringify(listado));
              } catch (e) { }
            }

            // Si NO hay un chat activo actualmente y hay parámetros en la ruta, seleccionar la conversación indicada
            if (!this.chatActivoId && this.$route && (this.$route.query?.id_telefono || this.$route.query?.numero || this.$route.query?.id_cliente || this.$route.params?.id_cliente || this.$route.params?.id_telefono)) {
              this.verificarSeleccionPorRuta();
            } else if (this.chatActivoId) {
              const encontrado = this.conversaciones.find(
                (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(this.chatActivoId)
              );
              if (encontrado) {
                this.chatSeleccionado = { ...encontrado, ...this.chatSeleccionado };
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error al cargar conversaciones recientes:", error);
        })
        .finally(() => {
          this.cargandoConversaciones = false;
        });
    },
    cargarConversacionesArchivadas() {
      if (this.cargandoArchivadas) return;
      this.cargandoArchivadas = true;

      const params = {
        archivado: 1,
        pagina: this.paginaArchivados,
        por_pagina: this.por_pagina,
        porPagina: this.por_pagina,
        per_page: this.por_pagina
      };
      if (this.busqueda && this.busqueda.trim()) {
        params.busqueda = this.busqueda.trim();
        params.search = this.busqueda.trim();
      }

      WhatsappSrv.conversacionesArchivadas(params)
        .then((response) => {
          if (response && response.data) {
            const res = response.data;
            let listado = [];
            if (Array.isArray(res)) {
              listado = res;
            } else if (res.data && Array.isArray(res.data)) {
              listado = res.data;
            } else if (res.conversaciones && Array.isArray(res.conversaciones)) {
              listado = res.conversaciones;
            }

            if (res.last_page || res.ultima_pagina || res.totpag) {
              this.ultimaPaginaArchivados = Number(res.last_page || res.ultima_pagina || res.totpag) || 1;
            } else if (res.total !== undefined && this.por_pagina > 0) {
              this.ultimaPaginaArchivados = Math.ceil(Number(res.total) / this.por_pagina) || 1;
            } else {
              this.ultimaPaginaArchivados = 1;
            }

            if (res.current_page || res.pagina) {
              this.paginaArchivados = Number(res.current_page || res.pagina) || this.paginaArchivados;
            }
            if (res.total !== undefined) {
              this.totalArchivados = Number(res.total);
            } else {
              this.totalArchivados = listado.length;
            }

            this.conversacionesArchivadas = listado;

            if ((!this.busqueda || !this.busqueda.trim()) && this.paginaArchivados === 1) {
              try {
                localStorage.setItem("argusblack.whatsapp.conversaciones_archivadas", JSON.stringify(listado));
              } catch (e) { }
            }

            if (this.chatActivoId) {
              const encontrado = this.conversacionesArchivadas.find(
                (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(this.chatActivoId)
              );
              if (encontrado) {
                this.chatSeleccionado = { ...encontrado, ...this.chatSeleccionado };
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error al cargar conversaciones archivadas:", error);
        })
        .finally(() => {
          this.cargandoArchivadas = false;
        });
    },
    verificarSeleccionPorRuta() {
      const targetIdTel = this.$route?.query?.id_telefono || this.$route?.params?.id_telefono;
      const targetNumero = this.$route?.query?.numero || this.$route?.params?.numero;
      const targetIdCliente = this.$route?.query?.id_cliente || this.$route?.params?.id_cliente;

      if (!targetIdTel && !targetNumero && !targetIdCliente) return;

      let porRuta = null;
      const todasConversaciones = [
        ...(Array.isArray(this.conversaciones) ? this.conversaciones : []),
        ...(Array.isArray(this.conversacionesArchivadas) ? this.conversacionesArchivadas : [])
      ];

      // 1. Prioridad: Buscar en la lista de conversaciones cargadas
      if (todasConversaciones.length > 0) {
        if (targetIdTel) {
          porRuta = todasConversaciones.find(
            (c) => c && String(c.id || c.id_telefono_cliente || c.id_telefono) === String(targetIdTel)
          );
        }

        // 2. Prioridad: Buscar por número telefónico
        if (!porRuta && targetNumero) {
          const numLimpio = this.limpiarNumero(targetNumero);
          porRuta = todasConversaciones.find(
            (c) => c && this.limpiarNumero(c.numero) === numLimpio
          );
        }

        // 3. Prioridad: Buscar por ID de Cliente
        if (!porRuta && targetIdCliente) {
          porRuta = todasConversaciones.find(
            (c) => c && String(c.id_cliente || (c.cliente && c.cliente.id)) === String(targetIdCliente)
          );
        }
      }

      if (porRuta) {
        const porRutaId = porRuta.id || porRuta.id_telefono_cliente || porRuta.id_cliente;
        if (String(this.chatActivoId) !== String(porRutaId)) {
          this.seleccionarChat(porRuta);
        }
      } else if (targetIdTel || targetNumero) {
        // El chat especificado en la URL está en otra página o no está en la primera página de conversaciones
        // 1. Revisar si tenemos sus datos en caché de LocalStorage
        let chatRecuperado = null;
        try {
          const raw = localStorage.getItem(`argusblack.whatsapp.chat_${targetIdTel || this.limpiarNumero(targetNumero)}`);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && (parsed.id || parsed.numero)) {
              chatRecuperado = {
                id: parsed.id || targetIdTel,
                id_telefono_cliente: parsed.id || targetIdTel,
                id_cliente: parsed.id_cliente || targetIdCliente || null,
                numero: parsed.numero || targetNumero,
                prefijo: parsed.prefijo || "",
                nombre: parsed.nombre || "",
                cliente: parsed.contacto?.cliente || null,
                mensajes: parsed.mensajes || []
              };
            }
          }
        } catch (e) { }

        // 2. Si no hay caché, construir el objeto chat mínimo con los parámetros de la URL
        if (!chatRecuperado) {
          chatRecuperado = {
            id: targetIdTel ? Number(targetIdTel) || targetIdTel : null,
            id_telefono_cliente: targetIdTel ? Number(targetIdTel) || targetIdTel : null,
            id_cliente: targetIdCliente ? Number(targetIdCliente) || targetIdCliente : null,
            numero: targetNumero || "",
            nombre: targetNumero ? `+${targetNumero}` : "Contacto",
            mensajes: []
          };
        }

        const chatRecuperadoId = chatRecuperado.id || chatRecuperado.id_telefono_cliente;
        if (chatRecuperadoId && String(this.chatActivoId) !== String(chatRecuperadoId)) {
          this.seleccionarChat(chatRecuperado);
        }
      }
    },
    buscar(query) {
      this.busqueda = query;
      this.pagina = 1;
      this.paginaArchivados = 1;
      if (this.tabActiva === "archivados") {
        this.cargarConversacionesArchivadas();
      } else {
        this.cargarConversacionesRecientes();
      }
    },
    cargarPagina(nPag) {
      const pagNum = Number(nPag) || 1;
      if (this.tabActiva === "archivados") {
        this.paginaArchivados = pagNum;
        this.cargarConversacionesArchivadas();
      } else {
        this.pagina = pagNum;
        this.cargarConversacionesRecientes();
      }
    },
    actualizarEpp(nuevoEpp) {
      this.por_pagina = Number(nuevoEpp) || 10;
      this.pagina = 1;
      this.paginaArchivados = 1;
      try {
        localStorage.setItem("argusblack.whatsapp.por_pagina", this.por_pagina);
      } catch (e) { }
      this.cargarConversaciones();
    },
    limpiarNumero(num) {
      if (!num) return "";
      return String(num).replace(/\D/g, "");
    },
    cambiarTab(tab) {
      this.tabActiva = tab;
      if (tab === "archivados") {
        this.cargarConversacionesArchivadas();
      } else {
        this.cargarConversacionesRecientes();
      }
    },
    seleccionarChat(chat) {
      if (!chat) return;

      const idTelefono = chat.id || chat.id_telefono_cliente || chat.id_telefono;
      const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;

      // Si ya está seleccionado este mismo chat, no repetir peticiones
      if (this.chatSeleccionado && String(this.chatActivoId) === String(chatId)) {
        return;
      }

      // Si había un chat previo abierto, cerrar el estado de chateando en el servidor y en local
      if (this.chatSeleccionado) {
        const idTelefonoPrevio = this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente || this.chatSeleccionado.id_telefono;
        this.chatSeleccionado.chateando = 0;
        if (idTelefonoPrevio && String(idTelefonoPrevio) !== String(idTelefono)) {
          WhatsappSrv.actualizarChateando(idTelefonoPrevio, 0).catch(() => { });
        }
      }

      this.chatSeleccionado = chat;
      this.chatActivoId = chatId;
      this.sidebarVisible = false;

      // 1. Cargar caché inmediatamente desde LocalStorage (0ms de espera visual)
      // La clave primaria e inequívoca es el ID único del teléfono (idTelefono)
      const numLimpio = this.limpiarNumero(chat.numero);
      const keysAProbar = [
        idTelefono ? `argusblack.whatsapp.chat_${idTelefono}` : null,
        numLimpio ? `argusblack.whatsapp.chat_${numLimpio}` : null
      ].filter(Boolean);

      let mensajesEncontrados = [];
      for (const k of keysAProbar) {
        try {
          const raw = localStorage.getItem(k);
          if (raw) {
            const parsed = JSON.parse(raw);
            const msgs = parsed && Array.isArray(parsed.mensajes) ? parsed.mensajes : (Array.isArray(parsed) ? parsed : null);
            if (msgs && msgs.length > 0) {
              // Si la caché guardada pertenece explícitamente a otro id de teléfono, no usarla
              if (parsed.id && idTelefono && String(parsed.id) !== String(idTelefono)) {
                continue;
              }
              // Filtrar posibles temp_ corruptos en caché
              mensajesEncontrados = msgs.filter((m) => !(m && typeof m.id === "string" && m.id.startsWith("temp_")));
              break;
            }
          }
        } catch (e) { }
      }

      // Si aún no hay mensajes en caché pero la conversación tiene ultimo_mensaje_whatsapp, usarlo de inmediato
      if (mensajesEncontrados.length === 0 && (chat.ultimo_mensaje_whatsapp || chat.ultimo_mensaje_whatssap)) {
        const uMsg = chat.ultimo_mensaje_whatsapp || chat.ultimo_mensaje_whatssap;
        if (uMsg && typeof uMsg === "object") {
          mensajesEncontrados = [uMsg];
        }
      }

      // IMPORTANTE: Clonar el array para evitar que mensajesChatActivo y chat.mensajes compartan la misma referencia
      this.mensajesChatActivo = [...mensajesEncontrados];
      chat.mensajes = [...mensajesEncontrados];

      chat.noLeidos = 0;
      chat.mensajes_sin_leer = 0;
      chat.chateando = 1;

      // Solo enviar 1 petición única para el chat seleccionado
      if (idTelefono) {
        WhatsappSrv.actualizarChateando(idTelefono, 1).catch(() => { });
      }

      const chatNumero = this.limpiarNumero(chat.numero);
      this.suscribirCanalConversacion(chatNumero);

      // Sincronizar query en la URL para reflejar el chat actualmente abierto
      if (this.$router && this.$route) {
        const idCli = chat.id_cliente || (chat.cliente && chat.cliente.id) || undefined;
        const currentQuery = this.$route.query || {};
        if (
          String(currentQuery.id_telefono || "") !== String(idTelefono || "") ||
          String(currentQuery.numero || "") !== String(chatNumero || "") ||
          String(currentQuery.id_cliente || "") !== String(idCli || "")
        ) {
          const nuevaQuery = { ...currentQuery };
          if (idTelefono) nuevaQuery.id_telefono = idTelefono;
          else delete nuevaQuery.id_telefono;
          if (chatNumero) nuevaQuery.numero = chatNumero;
          else delete nuevaQuery.numero;
          if (idCli) nuevaQuery.id_cliente = idCli;
          else delete nuevaQuery.id_cliente;

          this.$router.replace({ query: nuevaQuery }).catch(() => { });
        }
      }

      this.cargarMensajes(idTelefono);
    },
    cargarMensajes(idTelefono) {
      if (!idTelefono) return;
      this.cargandoMensajes = true;
      this.cargandoMasMensajes = false;
      this.noHayMasMensajesHistoricos = false;

      // Cancelar cualquier petición en vuelo previa al cambiar de chat
      if (this.abortControllerMensajes) {
        this.abortControllerMensajes.abort();
        this.abortControllerMensajes = null;
      }
      this.abortControllerMensajes = new AbortController();

      WhatsappSrv.mensajes(idTelefono, { signal: this.abortControllerMensajes.signal })
        .then((response) => {
          // Verificar que el chat seleccionado siga siendo el mismo
          const chatActual = this.chatSeleccionado;
          const idActual = chatActual ? (chatActual.id || chatActual.id_telefono_cliente || chatActual.id_telefono) : null;
          if (!chatActual || String(idActual) !== String(idTelefono)) {
            return;
          }

          const res = response && response.data !== undefined ? response.data : response;
          let listado = [];
          if (Array.isArray(res)) {
            listado = res;
          } else if (res && Array.isArray(res.data)) {
            listado = res.data;
          } else if (res && Array.isArray(res.mensajes)) {
            listado = res.mensajes;
          } else if (res && res.data && Array.isArray(res.data.mensajes)) {
            listado = res.data.mensajes;
          }

          this.mensajesChatActivo = listado;
          if (this.chatSeleccionado) {
            this.chatSeleccionado.mensajes = listado;
          }
          this.cargarMensajesNuevos(true);

          // Guardar explícitamente en LocalStorage bajo el ID único del teléfono (excluyendo temporales)
          try {
            const numLimpio = this.limpiarNumero(chatActual.numero);
            const listadoLimpio = listado.filter((m) => !(m && typeof m.id === "string" && m.id.startsWith("temp_")));
            const cacheData = {
              id: idTelefono,
              numero: numLimpio,
              mensajes: listadoLimpio.slice(-150),
              total_mensajes: listadoLimpio.length,
              actualizado_en: new Date().toISOString()
            };
            const jsonStr = JSON.stringify(cacheData);
            if (idTelefono) localStorage.setItem(`argusblack.whatsapp.chat_${idTelefono}`, jsonStr);
            try {
              localStorage.removeItem("argusblack.whatsapp.chat_activo");
            } catch (e) { }
          } catch (e) { }
        })
        .catch((error) => {
          if (error && (error.name === "AbortError" || error.name === "CanceledError" || error.code === "ERR_CANCELED" || error.message === "canceled")) {
            return; // Cancelación deliberada por cambio de chat
          }
          console.error("Error al cargar mensajes:", error);
        })
        .finally(() => {
          const chatActual = this.chatSeleccionado;
          const idActual = chatActual ? (chatActual.id || chatActual.id_telefono_cliente || chatActual.id_telefono) : null;
          if (!chatActual || String(idActual) === String(idTelefono)) {
            this.cargandoMensajes = false;
          }
        });
    },
    cargarMasMensajesHistoricos(callbackScroll) {
      if (!this.chatSeleccionado || this.cargandoMasMensajes || this.noHayMasMensajesHistoricos) return;

      const idTelefono = this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente || this.chatSeleccionado.id_telefono;
      if (!idTelefono) return;

      // Buscar el ID mínimo de la lista actual (excluyendo IDs temporales)
      let minId = null;
      if (Array.isArray(this.mensajesChatActivo)) {
        for (const m of this.mensajesChatActivo) {
          const numId = Number(m?.id);
          if (!isNaN(numId) && numId > 0 && !(typeof m.id === "string" && m.id.startsWith("temp_"))) {
            if (minId === null || numId < minId) {
              minId = numId;
            }
          }
        }
      }

      if (!minId) {
        this.noHayMasMensajesHistoricos = true;
        return;
      }

      this.cargandoMasMensajes = true;
      WhatsappSrv.mensajes(idTelefono, { params: { before_id: minId, limit: 50 } })
        .then((response) => {
          const chatActual = this.chatSeleccionado;
          const idActual = chatActual ? (chatActual.id || chatActual.id_telefono_cliente || chatActual.id_telefono) : null;
          if (!chatActual || String(idActual) !== String(idTelefono)) return;

          const res = response && response.data !== undefined ? response.data : response;
          let listado = [];
          if (Array.isArray(res)) listado = res;
          else if (res && Array.isArray(res.data)) listado = res.data;
          else if (res && Array.isArray(res.mensajes)) listado = res.mensajes;

          if (!listado || listado.length === 0) {
            this.noHayMasMensajesHistoricos = true;
            return;
          }

          // Unir manteniendo mensajes previos y preservando la posición de scroll
          const idsExistentes = new Set(this.mensajesChatActivo.map((m) => String(m.id || m.wamid)));
          const nuevos = listado.filter((m) => {
            const key = String(m.id || m.wamid);
            return !idsExistentes.has(key);
          });

          if (nuevos.length === 0) {
            this.noHayMasMensajesHistoricos = true;
            return;
          }

          this.mensajesChatActivo = [...nuevos, ...this.mensajesChatActivo];
          if (this.chatSeleccionado) {
            this.chatSeleccionado.mensajes = this.mensajesChatActivo;
          }

          if (typeof callbackScroll === "function") {
            this.$nextTick(() => {
              callbackScroll();
            });
          }
        })
        .catch((err) => {
          console.error("Error al cargar lote anterior de mensajes:", err);
        })
        .finally(() => {
          this.cargandoMasMensajes = false;
        });
    },
    enviarMensaje(payloadMensaje) {
      if (!payloadMensaje || !this.chatSeleccionado) return;
      if (this.enviandoMensaje) return;

      const chat = this.chatSeleccionado;
      const idTelefono = chat.id || chat.id_telefono_cliente;
      if (!idTelefono) return;

      const esObjeto = typeof payloadMensaje === "object" && payloadMensaje !== null;
      const tieneArchivo = esObjeto && Boolean(payloadMensaje.archivo);
      const tipoMensaje = esObjeto && payloadMensaje.tipo ? payloadMensaje.tipo : (tieneArchivo ? "document" : "text");
      const texto = esObjeto ? (payloadMensaje.caption || payloadMensaje.mensaje || "") : String(payloadMensaje);

      if (!tieneArchivo && (!texto || !texto.trim())) return;

      this.enviandoMensaje = true;

      const ahoraIso = new Date().toISOString();
      const tempId = "temp_" + Date.now();
      const textoLimpio = texto.trim();

      let previewUrl = null;
      let filename = null;
      if (tieneArchivo) {
        try {
          previewUrl = URL.createObjectURL(payloadMensaje.archivo);
          filename = payloadMensaje.archivo.name;
        } catch (e) { }
      }

      const nuevoMsg = {
        id: tempId,
        id_cliente: chat.id_cliente || (chat.cliente && chat.cliente.id),
        id_telefono_cliente: idTelefono,
        destinatario: (chat.prefijo || "") + (chat.numero || ""),
        tipo: tipoMensaje,
        estado: "pending",
        texto: textoLimpio,
        mensaje: textoLimpio,
        url_imagen: previewUrl,
        media_url: previewUrl,
        filename: filename,
        context: (payloadMensaje.id_mensaje_citado || payloadMensaje.wamid_citado) ? {
          id: payloadMensaje.wamid_citado || payloadMensaje.id_mensaje_citado,
          message_id: payloadMensaje.wamid_citado || payloadMensaje.id_mensaje_citado,
          from: payloadMensaje.es_saliente_citado ? "me" : ((chat.prefijo || "") + (chat.numero || "")),
          direccion: payloadMensaje.es_saliente_citado ? "saliente" : "entrante",
          texto: payloadMensaje.texto_citado || "",
          tipo: payloadMensaje.tipo_citado || "text"
        } : null,
        payload: JSON.stringify({
          mensaje: textoLimpio,
          caption: textoLimpio,
          type: tipoMensaje,
          filename: filename,
          context: (payloadMensaje.id_mensaje_citado || payloadMensaje.wamid_citado) ? {
            id: payloadMensaje.wamid_citado || payloadMensaje.id_mensaje_citado,
            message_id: payloadMensaje.wamid_citado || payloadMensaje.id_mensaje_citado,
            from: payloadMensaje.es_saliente_citado ? "me" : ((chat.prefijo || "") + (chat.numero || "")),
            direccion: payloadMensaje.es_saliente_citado ? "saliente" : "entrante",
            texto: payloadMensaje.texto_citado || "",
            tipo: payloadMensaje.tipo_citado || "text"
          } : null,
          meta_request: {
            type: tipoMensaje,
            [tipoMensaje]: {
              link: previewUrl,
              filename: filename,
              caption: textoLimpio
            }
          }
        }),
        created_at: ahoraIso,
        updated_at: ahoraIso,
        direccion: "saliente"
      };

      this.mensajesChatActivo.push(nuevoMsg);
      if (!chat.mensajes) {
        chat.mensajes = [];
      }
      if (chat.mensajes !== this.mensajesChatActivo && !chat.mensajes.includes(nuevoMsg)) {
        chat.mensajes.push(nuevoMsg);
      }
      chat.ultimo_mensaje_whatsapp = nuevoMsg;
      chat.ultimo_mensaje_whatssap = nuevoMsg;

      let apiPayload = null;
      if (tieneArchivo) {
        apiPayload = new FormData();
        apiPayload.append("archivo", payloadMensaje.archivo);
        apiPayload.append("tipo", tipoMensaje);
        if (textoLimpio) {
          apiPayload.append("mensaje", textoLimpio);
          apiPayload.append("caption", textoLimpio);
        }
        if (payloadMensaje.id_mensaje_citado) {
          apiPayload.append("id_mensaje_citado", payloadMensaje.id_mensaje_citado);
        }
        if (payloadMensaje.wamid_citado) {
          apiPayload.append("wamid_citado", payloadMensaje.wamid_citado);
        }
      } else {
        apiPayload = {
          mensaje: textoLimpio,
          tipo: "text",
          ...(payloadMensaje.id_mensaje_citado ? { id_mensaje_citado: payloadMensaje.id_mensaje_citado } : {}),
          ...(payloadMensaje.wamid_citado ? { wamid_citado: payloadMensaje.wamid_citado } : {})
        };
      }

      WhatsappSrv.enviarMensaje(idTelefono, apiPayload)
        .then((response) => {
          nuevoMsg.estado = "sent";
          if (response && response.data) {
            const data = response.data.data || response.data;
            const resId = data.id ? String(data.id) : null;
            let resWamid = data.wamid || null;
            if (!resWamid && data.payload) {
              try {
                const p = typeof data.payload === "string" ? JSON.parse(data.payload) : data.payload;
                resWamid = p.wamid || p.meta_response?.messages?.[0]?.id || null;
              } catch (e) { }
            }

            // Verificar si el evento de WebSocket ya agregó este mensaje a la lista
            const idxExistente = this.mensajesChatActivo.findIndex(
              (m) => m !== nuevoMsg && (
                (resId && String(m.id) === resId) ||
                (resWamid && (m.wamid === resWamid || this.obtenerWamid(m) === resWamid)) ||
                (textoLimpio && esSaliente(m, this.chatSeleccionado) && this.extraerTexto(m) === textoLimpio)
              )
            );

            if (idxExistente !== -1) {
              // El mensaje ya fue insertado por WebSocket: fusionar URLs de preview y descartar el duplicado temporal
              const existente = this.mensajesChatActivo[idxExistente];
              existente.url_imagen = existente.url_imagen || nuevoMsg.url_imagen;
              existente.media_url = existente.media_url || nuevoMsg.media_url;
              existente.filename = existente.filename || nuevoMsg.filename;
              const idxTemp = this.mensajesChatActivo.indexOf(nuevoMsg);
              if (idxTemp !== -1) {
                this.mensajesChatActivo.splice(idxTemp, 1);
              }
            } else {
              if (data.id) nuevoMsg.id = data.id;
              if (resWamid) nuevoMsg.wamid = resWamid;
              if (data.id_mensaje) nuevoMsg.id_mensaje = data.id_mensaje;
              if (data.payload) {
                nuevoMsg.payload = data.payload;
                delete nuevoMsg._parsedPayload;
                delete nuevoMsg._lastRawPayload;
              }
              if (data.created_at) nuevoMsg.created_at = data.created_at;
              if (data.direccion) nuevoMsg.direccion = data.direccion;
              else nuevoMsg.direccion = "saliente";
            }
          }
          this.mensajesChatActivo = [...this.mensajesChatActivo];
          if (this.chatSeleccionado) {
            this.chatSeleccionado.mensajes = this.mensajesChatActivo;
            guardarConversacionEnCache(this.chatSeleccionado, this.mensajesChatActivo);
          }
        })
        .catch((error) => {
          console.error("Error al enviar mensaje:", error);
          nuevoMsg.estado = "failed";
          nuevoMsg.error_mensaje = error?.response?.data?.message || "Error al enviar mensaje";
          this.mensajesChatActivo = [...this.mensajesChatActivo];
        })
        .finally(() => {
          this.enviandoMensaje = false;
        });
    },
    inicializarConversacion(chat) {
      const c = chat || this.chatSeleccionado;
      if (!c) return;
      if (this.$refs.mdlEnviarPlantilla) {
        this.$refs.mdlEnviarPlantilla.abrir(c);
      }
    },
    onPlantillaEnviada(payload) {
      const c = payload?.chat || this.chatSeleccionado;
      const idTelefono = c?.id || c?.id_telefono_cliente || c?.id_telefono;
      if (idTelefono) {
        this.cargarMensajes(idTelefono);
      }
      this.cargarConversaciones();
    },
    cerrarChat() {
      this.desuscribirCanalConversacion();
      if (this.chatSeleccionado) {
        const idTelefono = this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente;
        if (idTelefono) {
          WhatsappSrv.actualizarChateando(idTelefono, 0).catch(() => { });
        }
        this.chatSeleccionado.chateando = 0;
      }
      try {
        localStorage.removeItem("argusblack.whatsapp.chat_activo");
      } catch (e) { }
      this.chatSeleccionado = null;
      this.chatActivoId = null;
      this.mensajesChatActivo = [];
      this.panelInfoVisible = false;
      this.sidebarVisible = false;
      if (this.$router && this.$route) {
        if (this.$route.params && this.$route.params.id_cliente) {
          this.$router.replace({ name: "whatsappMensajes" }).catch(() => { });
        } else if (this.$route.query && (this.$route.query.id_telefono || this.$route.query.numero || this.$route.query.id_cliente)) {
          const limpia = { ...this.$route.query };
          delete limpia.id_telefono;
          delete limpia.numero;
          delete limpia.id_cliente;
          this.$router.replace({ query: limpia }).catch(() => { });
        }
      }
    },
    irADetalleCliente(chat) {
      const id = chat.id_cliente || (chat.cliente && chat.cliente.id) || chat.id;
      if (id) {
        this.$router.push({ name: "tableroCliente", params: { id_cliente: id } }).catch(() => { });
      }
    },
    marcarComoNoLeido(chat) {
      if (!chat) return;
      if (chat.ultimo_mensaje_whatsapp) {
        chat.ultimo_mensaje_whatsapp.fecha_lectura = null;
      }
      chat.mensajes_sin_leer = (Number(chat.mensajes_sin_leer) || 0) + 1;
      chat.noLeidos = (chat.noLeidos || 0) + 1;

      // Si este chat era el que estaba activo en la ventana, cerramos la vista activa para que se vea el badge
      const idTel = chat.id || chat.id_telefono_cliente || chat.id_telefono;
      const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;
      if (this.chatActivoId && String(this.chatActivoId) === String(chatId)) {
        this.cerrarChat();
      }

      // Forzar reactividad del listado de conversaciones
      this.conversaciones = [...this.conversaciones];

      if (idTel) {
        WhatsappSrv.marcarComoNoLeido(idTel)
          .then((res) => {
            const data = res?.data || res;
            if (data?.telefono_cliente) {
              chat.mensajes_sin_leer = Number(data.telefono_cliente.mensajes_sin_leer) || 1;
              this.conversaciones = [...this.conversaciones];
            }
          })
          .catch((err) => {
            console.error("Error al marcar chat como no leído en backend:", err);
          });
      }
    },
    silenciarContacto(chat) {
      chat.silenciado = !chat.silenciado;
    },
    fijarContacto(chat) {
      chat.fijado = !chat.fijado;
    },
    archivarContacto(chat) {
      if (!chat) return;
      chat.archivado = 1;
      const idTelefono = chat.id || chat.id_telefono_cliente || chat.id_telefono || (chat.cliente && chat.cliente.id_telefono);
      const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;

      this.conversaciones = this.conversaciones.filter(
        (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) !== String(chatId)
      );
      if (!this.conversacionesArchivadas.some((c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(chatId))) {
        this.conversacionesArchivadas = [chat, ...this.conversacionesArchivadas];
        this.totalArchivados = (Number(this.totalArchivados) || 0) + 1;
      }

      if (String(this.chatActivoId) === String(chatId) && this.tabActiva === "recientes") {
        this.cerrarChat();
      }

      if (idTelefono) {
        WhatsappSrv.actualizarTelefonoCliente(idTelefono, { archivado: 1 })
          .then(() => {
            this.cargarConversaciones();
          })
          .catch(() => { });
      }
    },
    desarchivarContacto(chat) {
      if (!chat) return;
      chat.archivado = 0;
      const idTelefono = chat.id || chat.id_telefono_cliente || chat.id_telefono || (chat.cliente && chat.cliente.id_telefono);
      const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;

      this.conversacionesArchivadas = this.conversacionesArchivadas.filter(
        (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) !== String(chatId)
      );
      this.totalArchivados = Math.max((Number(this.totalArchivados) || 1) - 1, 0);
      if (!this.conversaciones.some((c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(chatId))) {
        this.conversaciones = [chat, ...this.conversaciones];
      }

      if (String(this.chatActivoId) === String(chatId) && this.tabActiva === "archivados") {
        this.cerrarChat();
      }

      if (idTelefono) {
        WhatsappSrv.actualizarTelefonoCliente(idTelefono, { archivado: 0 })
          .then(() => {
            this.cargarConversaciones();
          })
          .catch(() => { });
      }
    },
    vaciarChat(chat) {
      if (!chat) return;
      const idTel = chat.id || chat.id_telefono_cliente || chat.id_telefono || (chat.cliente && chat.cliente.id_telefono);
      if (!idTel) return;

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger me-2",
          cancelButton: "btn btn-secondary"
        },
        buttonsStyling: false
      });

      const nombre = (chat.cliente && (chat.cliente.nombre || chat.cliente.nombre_completo)) || chat.nombre || chat.numero || "esta conversación";

      swal.fire({
        title: "¿Vaciar chat?",
        html: `¿Estás seguro de que deseas vaciar los mensajes con <strong>${nombre}</strong>?<br><small class="text-muted">Se eliminarán todos los mensajes de esta conversación.</small>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: '<i class="mdi mdi-broom me-1"></i> Sí, vaciar',
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          WhatsappSrv.vaciarChat(idTel)
            .then(() => {
              const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;
              this.mensajesChatActivo = [];
              if (this.chatSeleccionado) {
                this.chatSeleccionado.mensajes = [];
                this.chatSeleccionado.ultimo_mensaje_whatsapp = null;
                this.chatSeleccionado.ultimo_mensaje_whatssap = null;
                this.chatSeleccionado.ultimo_mensaje = null;
              }

              // Actualizar el objeto chat y cualquier referencia en la lista de conversaciones
              [this.conversaciones, this.conversacionesArchivadas].forEach((lista) => {
                if (Array.isArray(lista)) {
                  lista.forEach((c) => {
                    const cIdTel = c.id || c.id_telefono_cliente || c.id_telefono;
                    if (String(cIdTel) === String(idTel)) {
                      c.ultimo_mensaje_whatsapp = null;
                      c.ultimo_mensaje_whatssap = null;
                      c.ultimo_mensaje = null;
                      c.mensajes = [];
                    }
                  });
                }
              });
              this.conversaciones = [...this.conversaciones];
              this.conversacionesArchivadas = [...this.conversacionesArchivadas];
              this.cargarMensajesNuevos(true);

              // Limpiar caché de localStorage para este chat específico
              eliminarCacheChat(chat);
              try {
                localStorage.removeItem(`argusblack.whatsapp.chat_${idTel}`);
                localStorage.setItem("argusblack.whatsapp.conversaciones", JSON.stringify(this.conversaciones));
              } catch (e) { }

              if (typeof iu !== "undefined" && iu.msg) {
                iu.msg.success("Chat vaciado correctamente");
              }
            })
            .catch((error) => {
              console.error("Error al vaciar chat:", error);
              const msg = error.response?.data?.message || "No se pudo vaciar el chat";
              if (typeof iu !== "undefined" && iu.msg) {
                iu.msg.error(msg);
              }
            });
        }
      });
    },
    eliminarChat(chat) {
      if (!chat) return;
      const idTel = chat.id || chat.id_telefono_cliente || chat.id_telefono || (chat.cliente && chat.cliente.id_telefono);
      const pref = chat.prefijo ? `${chat.prefijo} ` : "";
      const numCompleto = `${pref}${chat.numero || ""}`.trim();

      const ejecutarOcultarChat = () => {
        if (idTel) {
          WhatsappSrv.actualizarTelefonoCliente(idTel, { chat: 0 }).catch(() => { });
        }
        // Limpiar caché de localStorage para este chat
        const numLimpio = this.limpiarNumero(chat.numero);
        try {
          localStorage.removeItem(`argusblack.whatsapp.chat_${idTel || numLimpio}`);
          const activoRaw = localStorage.getItem("argusblack.whatsapp.chat_activo");
          if (activoRaw) {
            const activo = JSON.parse(activoRaw);
            if (activo && (activo.id === idTel || activo.numero === chat.numero)) {
              localStorage.removeItem("argusblack.whatsapp.chat_activo");
            }
          }
        } catch (e) { }

        const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;
        if (Array.isArray(this.conversaciones)) {
          const idx = this.conversaciones.findIndex(
            (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(chatId)
          );
          if (idx !== -1) {
            this.conversaciones.splice(idx, 1);
          }
        }
        if (Array.isArray(this.conversacionesArchivadas)) {
          const idxArch = this.conversacionesArchivadas.findIndex(
            (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(chatId)
          );
          if (idxArch !== -1) {
            this.conversacionesArchivadas.splice(idxArch, 1);
            this.totalArchivados = Math.max((Number(this.totalArchivados) || 1) - 1, 0);
          }
        }
        if (String(this.chatActivoId) === String(chatId) || String(this.chatActivoId) === String(idTel)) {
          this.cerrarChat();
        }
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.success("Chat eliminado de la lista de conversaciones");
        }
      };

      Swal.fire({
        title: "¿Eliminar chat?",
        text: `¿Desea eliminar la conversación con ${numCompleto} de la lista de chats activos?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#74788d",
        confirmButtonText: '<i class="mdi mdi-chat-remove-outline me-1"></i> Sí, eliminar chat',
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          ejecutarOcultarChat();
        }
      });
    },
    abrirModalAsignarCliente(chat) {
      const c = chat || this.chatSeleccionado;
      if (!c) return;
      if (this.$refs.mdlAsignarCliente) {
        this.$refs.mdlAsignarCliente.abrir(c);
      }
    },
    abrirModalInicializarConversacion() {
      if (this.$refs.mdlInicializarConversacion) {
        this.$refs.mdlInicializarConversacion.abrir();
      }
    },
    onConversacionIniciada(payload) {
      const tel = payload?.telefono_cliente;
      if (!tel) {
        this.cargarConversaciones();
        return;
      }

      // Si viene el objeto de cliente, anexarlo
      if (payload.cliente && !tel.cliente) {
        tel.cliente = payload.cliente;
      }

      // Verificar si ya existe en conversaciones o insertarlo al principio
      if (Array.isArray(this.conversaciones)) {
        const idTel = tel.id || tel.id_telefono_cliente;
        const yaExiste = this.conversaciones.some((c) => c && String(c.id || c.id_telefono_cliente) === String(idTel));
        if (!yaExiste) {
          this.conversaciones = [tel, ...this.conversaciones];
        }
      }

      // Seleccionar de inmediato el nuevo chat para abrirlo
      this.tabActiva = "recientes";
      this.seleccionarChat(tel);
      this.cargarConversaciones();
    },
    onClienteAsignado(payload) {
      const idTelefono = payload.id_telefono;
      const nuevoCliente = payload.cliente;

      // Actualizar en el chat seleccionado si corresponde
      if (this.chatSeleccionado && String(this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente) === String(idTelefono)) {
        this.chatSeleccionado = {
          ...this.chatSeleccionado,
          id_cliente: nuevoCliente.id,
          cliente: {
            ...(this.chatSeleccionado.cliente || {}),
            ...nuevoCliente,
            generico: false
          }
        };
      }

      // Actualizar en el array de conversaciones
      if (Array.isArray(this.conversaciones)) {
        const idx = this.conversaciones.findIndex(
          (c) => c && String(c.id || c.id_telefono_cliente) === String(idTelefono)
        );
        if (idx !== -1) {
          this.conversaciones[idx] = {
            ...this.conversaciones[idx],
            id_cliente: nuevoCliente.id,
            cliente: {
              ...(this.conversaciones[idx].cliente || {}),
              ...nuevoCliente,
              generico: false
            }
          };
        }
      }

      // Refrescar conversaciones para sincronizar cualquier detalle adicional
      this.cargarConversaciones({ pagina: this.pagina, por_pagina: this.por_pagina });
    },
    eliminarTelefonoCliente(chat) {
      if (!chat) return;
      const idTel = chat.id || chat.id_telefono_cliente || chat.id_telefono;
      if (!idTel) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("No se encontró el ID del teléfono a eliminar");
        }
        return;
      }

      const pref = chat.prefijo ? `${chat.prefijo} ` : "";
      const numCompleto = `${pref}${chat.numero || ""}`.trim();

      const ejecutarEliminacionDefinitiva = () => {
        WhatsappSrv.eliminarTelefonoCliente(idTel)
          .then((response) => {
            const data = response?.data || {};
            if (typeof iu !== "undefined" && iu.msg) {
              iu.msg.success(data.message || "Número de teléfono eliminado permanentemente");
            }
            // Eliminar de las conversaciones en pantalla y memoria
            const chatId = chat.id || chat.id_telefono_cliente || chat.id_cliente;
            if (Array.isArray(this.conversaciones)) {
              const idx = this.conversaciones.findIndex(
                (c) => c && String(c.id || c.id_telefono_cliente || c.id_cliente) === String(chatId)
              );
              if (idx !== -1) {
                this.conversaciones.splice(idx, 1);
              }
            }
            if (String(this.chatActivoId) === String(chatId) || String(this.chatActivoId) === String(idTel)) {
              this.cerrarChat();
            }
            this.cargarConversaciones({ pagina: this.pagina, por_pagina: this.por_pagina });
          })
          .catch((error) => {
            let msg = "No se pudo eliminar el teléfono de la base de datos";
            try {
              msg = error.response.data.message || msg;
            } catch (e) { }
            if (typeof iu !== "undefined" && iu.msg) {
              iu.msg.error(msg);
            }
          });
      };

      Swal.fire({
        title: "¿Eliminar número de teléfono?",
        text: `¿Está seguro de que desea eliminar permanentemente el número ${numCompleto} de la base de datos de teléfonos?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#74788d",
        confirmButtonText: '<i class="mdi mdi-phone-remove-outline me-1"></i> Sí, eliminar número',
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          ejecutarEliminacionDefinitiva();
        }
      });
    },
    bloquearContacto(chat) {
      if (!chat || this.procesandoBloqueo) return;
      const idTel = chat.id || chat.id_telefono_cliente || chat.id_telefono;
      if (!idTel) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("No se encontró el ID del teléfono para bloquear");
        }
        return;
      }

      // Cerrar dropdown si estaba abierto
      document.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));

      const pref = chat.prefijo ? `${chat.prefijo} ` : "";
      const numCompleto = `${pref}${chat.numero || ""}`.trim();

      const ejecutarBloqueo = () => {
        this.procesandoBloqueo = true;
        WhatsappSrv.bloquearTelefonoCliente(idTel)
          .then((response) => {
            const data = response?.data || {};
            // Actualizar objeto localmente
            chat.bloqueado = 1;
            if (this.chatSeleccionado && String(this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente) === String(idTel)) {
              this.chatSeleccionado.bloqueado = 1;
            }

            [this.conversaciones, this.conversacionesArchivadas].forEach((lista) => {
              if (Array.isArray(lista)) {
                lista.forEach((c) => {
                  const cId = c.id || c.id_telefono_cliente || c.id_telefono;
                  if (String(cId) === String(idTel)) {
                    c.bloqueado = 1;
                  }
                });
              }
            });
            this.conversaciones = [...this.conversaciones];
            this.conversacionesArchivadas = [...this.conversacionesArchivadas];

            if (typeof iu !== "undefined" && iu.msg) {
              iu.msg.success(data.message || "Número bloqueado correctamente");
            }
          })
          .catch((error) => {
            console.error("Error al bloquear contacto:", error);
            const msg = error.response?.data?.message || "No se pudo bloquear el número de teléfono";
            if (typeof iu !== "undefined" && iu.msg) {
              iu.msg.error(msg);
            }
          })
          .finally(() => {
            this.procesandoBloqueo = false;
          });
      };

      Swal.fire({
        title: "¿Bloquear número de teléfono?",
        html: `¿Estás seguro de que deseas bloquear el número <strong>${numCompleto}</strong>?<br><small class="text-muted">No se podrán enviar mensajes a este número ni recibirá interacción por WhatsApp.</small>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#74788d",
        confirmButtonText: '<i class="mdi mdi-block-helper me-1"></i> Sí, bloquear',
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          ejecutarBloqueo();
        }
      });
    },
    desbloquearContacto(chat) {
      if (!chat || this.procesandoBloqueo) return;
      const idTel = chat.id || chat.id_telefono_cliente || chat.id_telefono;
      if (!idTel) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("No se encontró el ID del teléfono para desbloquear");
        }
        return;
      }

      // Cerrar dropdown si estaba abierto
      document.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));

      this.procesandoBloqueo = true;
      WhatsappSrv.desbloquearTelefonoCliente(idTel)
        .then((response) => {
          const data = response?.data || {};
          chat.bloqueado = 0;
          if (this.chatSeleccionado && String(this.chatSeleccionado.id || this.chatSeleccionado.id_telefono_cliente) === String(idTel)) {
            this.chatSeleccionado.bloqueado = 0;
          }

          [this.conversaciones, this.conversacionesArchivadas].forEach((lista) => {
            if (Array.isArray(lista)) {
              lista.forEach((c) => {
                const cId = c.id || c.id_telefono_cliente || c.id_telefono;
                if (String(cId) === String(idTel)) {
                  c.bloqueado = 0;
                }
              });
            }
          });
          this.conversaciones = [...this.conversaciones];
          this.conversacionesArchivadas = [...this.conversacionesArchivadas];

          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.success(data.message || "Número desbloqueado correctamente");
          }
        })
        .catch((error) => {
          console.error("Error al desbloquear contacto:", error);
          const msg = error.response?.data?.message || "No se pudo desbloquear el número de teléfono";
          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.error(msg);
          }
        })
        .finally(() => {
          this.procesandoBloqueo = false;
        });
    },
    extraerTexto(m) {
      if (!m) return "";
      if (typeof m.texto === "string" && m.texto.trim()) return m.texto.trim();
      if (typeof m.mensaje === "string" && m.mensaje.trim()) return m.mensaje.trim();
      if (typeof m.cuerpo === "string" && m.cuerpo.trim()) return m.cuerpo.trim();
      if (typeof m.body === "string" && m.body.trim()) return m.body.trim();
      if (typeof m.text === "string" && m.text.trim()) return m.text.trim();
      if (m.text?.body) return m.text.body.trim();
      let p = m.payload;
      if (typeof p === "string") {
        try { p = JSON.parse(p); } catch (e) { p = {}; }
      }
      if (p && typeof p === "object") {
        if (p.caption && typeof p.caption === "string") return p.caption.trim();
        if (p.cuerpo && typeof p.cuerpo === "string") return p.cuerpo.trim();
        if (p.meta_request?.caption && typeof p.meta_request.caption === "string") return p.meta_request.caption.trim();
        if (p.meta_request?.image?.caption) return p.meta_request.image.caption.trim();
        if (p.meta_request?.document?.caption) return p.meta_request.document.caption.trim();
        if (p.meta_request?.video?.caption) return p.meta_request.video.caption.trim();
        if (p.meta_request?.text?.body) return p.meta_request.text.body.trim();
        if (p.meta_request?.body) return p.meta_request.body.trim();
        if (p.meta_request?.mensaje) return p.meta_request.mensaje.trim();
        if (p.meta_request?.cuerpo) return p.meta_request.cuerpo.trim();
        if (p.mensaje && typeof p.mensaje === "string") return p.mensaje.trim();
        if (p.texto && typeof p.texto === "string") return p.texto.trim();
        if (p.text) return (typeof p.text === "object" ? p.text.body : p.text).trim();
        if (p.body) return (typeof p.body === "object" ? p.body.text : p.body).trim();
      }
      return "";
    },
    obtenerWamid(msg) {
      if (!msg) return "";
      if (msg.wamid) return String(msg.wamid);
      if (typeof msg.id === "string" && msg.id.startsWith("wamid.")) return msg.id;
      let p = msg.payload;
      if (typeof p === "string") {
        try { p = JSON.parse(p); } catch (e) { p = {}; }
      }
      if (p && typeof p === "object") {
        if (p.wamid) return String(p.wamid);
        if (p.id && typeof p.id === "string" && p.id.startsWith("wamid.")) return p.id;
        if (p.messages?.[0]?.id) return p.messages[0].id;
        if (p.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.id) return p.entry[0].changes[0].value.messages[0].id;
        if (p.meta_response?.messages?.[0]?.id) return p.meta_response.messages[0].id;
      }
      return "";
    },
    coincideId(msg, targetId) {
      if (!msg || !targetId) return false;
      const target = String(targetId).trim();
      if (String(msg.id) === target) return true;
      const wamid = this.obtenerWamid(msg);
      if (wamid && wamid === target) return true;
      return false;
    },
    onConversacionesWhatsapp(data) {
      if (!data) return;
      if (this.timerDebounceConversaciones) {
        clearTimeout(this.timerDebounceConversaciones);
      }
      this.timerDebounceConversaciones = setTimeout(() => {
        this.timerDebounceConversaciones = null;
        if (this.tabActiva === "archivados") {
          this.cargarConversacionesArchivadas();
        } else {
          this.cargarConversacionesRecientes();
        }
      }, 350);
    },
    onMensajeWhatsapp(data) {
      if (!data) return;
      const msg = data.mensaje || data.data || data;
      const wamid = this.obtenerWamid(msg);
      const msgId = wamid || (msg.id ? String(msg.id) : null);

      let payload = {};
      if (typeof msg.payload === "string") {
        try { payload = JSON.parse(msg.payload); } catch (e) { }
      } else if (typeof msg.payload === "object" && msg.payload) {
        payload = msg.payload;
      }

      // 1. Status updates (sent, delivered, read, failed)
      const statuses = msg.statuses || payload.statuses || (msg.status && !msg.text && !msg.texto && !msg.mensaje && !payload.text && !payload.mensaje ? [msg] : null);
      if (statuses && Array.isArray(statuses) && statuses.length > 0) {
        statuses.forEach((st) => {
          const targetId = st.id || st.message_id || st.wamid;
          const statusName = st.status;
          if (targetId && statusName) {
            const target = this.mensajesChatActivo.find((m) => this.coincideId(m, targetId));
            if (target) {
              target.estado = statusName;
              if (statusName === "read") target.fecha_lectura = new Date().toISOString();
              else if (statusName === "delivered") target.fecha_entrega = new Date().toISOString();
            }
          }
        });
        this.mensajesChatActivo = [...this.mensajesChatActivo];
        return;
      }

      // 2. Reacciones
      const esReaccion = msg.type === "reaction" || msg.tipo === "reaction" || payload.type === "reaction" || Boolean(msg.reaction?.message_id) || Boolean(payload.reaction?.message_id);
      if (esReaccion) {
        const r = msg.reaction || payload.reaction || payload.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.reaction || payload.messages?.[0]?.reaction || {};
        const targetId = r.message_id || msg.message_id || payload.message_id;
        const emoji = r.emoji !== undefined ? r.emoji : (msg.emoji || "");

        if (targetId && this.mensajesChatActivo.length > 0) {
          const target = this.mensajesChatActivo.find((m) => this.coincideId(m, targetId));
          if (target) {
            target.reaccion = emoji ? emoji.trim() : null;
            this.mensajesChatActivo = [...this.mensajesChatActivo];
          }
        }
        return;
      }

      // 3. Buscar si el mensaje ya existe por su wamid o id
      let indexExistente = -1;
      if (msgId) {
        indexExistente = this.mensajesChatActivo.findIndex((m) => this.coincideId(m, msgId));
      }

      const esMsgSaliente = esSaliente(msg, this.chatSeleccionado);

      // Si no se encontró por ID y es un mensaje saliente, buscar si reemplaza a uno temporal (temp_)
      if (indexExistente === -1 && esMsgSaliente) {
        const textoMsg = this.extraerTexto(msg);
        const tipoMsg = msg.tipo || payload?.type || payload?.meta_request?.type || "text";
        const filenameMsg = msg.filename || payload?.filename || payload?.meta_request?.document?.filename || "";
        const fechaMsg = obtenerObjetoFecha(msg).getTime();

        indexExistente = this.mensajesChatActivo.findIndex((m) => {
          const esTemp = typeof m.id === "string" && m.id.startsWith("temp_");
          if (!esTemp) return false;

          // Si coincide por texto / caption
          if (textoMsg && this.extraerTexto(m) === textoMsg) return true;

          // Si coincide por archivo multimedia del mismo tipo
          const mTipo = m.tipo || "text";
          if (["image", "video", "audio", "document", "sticker"].includes(tipoMsg) && mTipo === tipoMsg) {
            const mFilename = m.filename || "";
            if (filenameMsg && mFilename && filenameMsg === mFilename) return true;
            const diff = Math.abs(obtenerObjetoFecha(m).getTime() - fechaMsg);
            if (diff < 120000) return true;
          }

          return false;
        });
      }

      if (indexExistente !== -1) {
        const itemViejo = this.mensajesChatActivo[indexExistente];
        this.mensajesChatActivo[indexExistente] = {
          ...itemViejo,
          ...msg,
          url_imagen: itemViejo.url_imagen || msg.url_imagen,
          media_url: itemViejo.media_url || msg.media_url,
          filename: itemViejo.filename || msg.filename,
          estado: msg.estado || itemViejo.estado || "sent"
        };
        this.mensajesChatActivo = [...this.mensajesChatActivo];
        return;
      }

      if (!msg.created_at && !msg.fecha_envio) {
        msg.created_at = new Date().toISOString();
      }

      this.mensajesChatActivo.push(msg);

      if (this.chatSeleccionado) {
        this.chatSeleccionado.ultimo_mensaje_whatsapp = msg;
        this.chatSeleccionado.tiempo = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      }
    }
  }
};
</script>
